import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 1.6001C8.62349 1.6003 9.12876 2.07764 9.12891 2.6665V6.87061H13.333C13.9221 6.87064 14.3994 7.37675 14.3994 8.00049C14.3992 8.62404 13.922 9.12936 13.333 9.12939H9.12891V13.3335C9.12887 13.9224 8.62355 14.3997 8 14.3999C7.37627 14.3999 6.87015 13.9226 6.87012 13.3335V9.12939H2.66602C2.07715 9.12925 1.59981 8.62397 1.59961 8.00049C1.59961 7.37682 2.07703 6.87075 2.66602 6.87061H6.87012V2.6665C6.87027 2.07752 7.37634 1.6001 8 1.6001Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
